<!--
 * @Author: 李明明
 * @Date: 2022-11-28 11:51:15
 * @LastEditTime: 2022-11-28 11:52:02
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/views/redirect/index.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
    <div>

    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>

</style>